import { SharedserviceMelcoModelsDesignListItem } from "melco-shared-logic";
import { useDesignThumbnailURL } from "../../../hooks/libraries/designs/useDesignThumbnailURL";
import { ListThumbnail } from "../../shared/ListThumbnail";


type DesignsListThumbnailProps = {
  design: SharedserviceMelcoModelsDesignListItem;
};

export const DesignsListThumbnail: React.FC<DesignsListThumbnailProps> = ({
  design,
}) => {
  const thumbnailSrc = useDesignThumbnailURL(
    design,
    64,
    64
    // spacings.xlarge,
    // spacings.xlarge
  );

  return <ListThumbnail thumbnailSrc={thumbnailSrc ?? undefined} />;
};
